import VProveedor from "./../views/Proveedores/VProveedor"
import VPaquestes from "../views/Paquetes/VPaquetes"
import ProveedorUsuarios from "../views/UsuariosProveedores/VUsuarios"
import VUsuarios from "./../views/Usuarios/VUsuarios"
import VCalendario from "../views/Calendario/VCalendario"
import VRoles from "../views/Roles/VRoles"
import VPagos from "../views/Pagos/VPagos"
import VPaquetesImagenes from "../views/PaqueteImagen/VPaquetesImagen"
import VMisComisiones from "../views/Comisiones/VMisComisiones"
import VClientes from "../views/AdministradorClientes/VClientes"
import VPagarComision from "../views/Comisiones/VPagarComision"
import VReportePagos from "../views/Comisiones/VReportePagos"
import VCompras from "../views/AdministradorClientes/VCompras"
import VEventos from "../views/Calendario/VEventos"
import VGrupoDetalle from "../views/Calendario/VGrupoDetalle"
import VClienteDetalle from "../views/Calendario/VClienteDetalle"
import VBienvenida from "../views/Home/VBienvenida"
import VFinanzas from "../views/Finanzas/VFinanzas"
import VCambios from '../views/Cambios/VCambios'
import VReservas from "../views/Reservas/VReservas"
import VAereo from "../views/Aereo/VAereo"
import VGrupoAereo from "../views/Aereo/VGrupoAereo"
import VGrupoAereoAuth from "../views/Aereo/VGrupoAereoAuth"
import VLiquidaciones from "../views/liquidaciones/VLiquidaciones"
import VGrupoLiquidaciones from "../views/liquidaciones/VGrupoLiquidaciones"
import VGrupoLiquidacionesAuth from "../views/liquidaciones/VGrupoLiquidacionesAuth"
import CambiosGrupales from "../views/CambiosMasivosFecha"
import VCotizador from "../views/Cotizador/VCotizador"
import VMetodoPago from "../views/MetodosPago/VMetodoPago"
import VReportes from "../views/Reportes/VReportes"
import VDevoluciones from "../views/Devoluciones/VDevoluciones"
import VFacturas from "../views/Facturas/VFacturas"
import VCotizaciones from "../views/Cotizaciones/VCotizaciones"
import VExtrasContratados from "../views/ExtrasContratados/VExtrasContratados"
import VCotizacionesAdmin from "../views/CotizacionesAdmin/VCotizaciones"
import PaqueteMain from "../views/PaqueteMain"
export const Rutas = [
    {
        key: "PK_Angenda_Viaje",
        Clave: "PK_Angenda_Viaje",
        path: "/Calendario",
        exact: true,
        component: VCalendario,
        autorizado: true
    },
    {
        key: "PK_Proveedores",
        Clave: "PK_Proveedores",
        path: "/Proveedor",
        exact: true,
        component: VProveedor,
        autorizado: true
    },
    {
        key: "PK_Agenda_Viaje_Eventos",
        Clave: "PK_Angenda_Viaje",
        path: "/Calendario/:fecha",
        exact: true,
        component: VEventos,
        autorizado: true
    },
    {
        key: "PK_Agenda_Viaje_Grupo",
        Clave: "PK_Angenda_Viaje",
        path: "/Grupo/:paquete/:fecha",
        exact: true,
        component: VGrupoDetalle,
        autorizado: true
    },
    {
        key: "PK_Agenda_Viaje_Cliente",
        Clave: "PK_Angenda_Viaje",
        path: "/ClienteDetalle/:referencia",
        exact: true,
        component: VClienteDetalle,
        autorizado: true
    },
    {
        key: "PK_ProveedorUsuauri",
        Clave: "PK_ProveedorUsuauri",
        path: "/ProveedorUsuario",
        exact: true,
        component: ProveedorUsuarios,
        autorizado: true
    },
    {
        key: "PK_Usuario",
        Clave: "PK_Usuario",
        path: "/Usuarios",
        exact: true,
        component: VUsuarios,
        autorizado: true
    },
    {
        key: "PK_Paquetes",
        Clave: "PK_Paquetes",
        path: "/Paquetes",
        exact: true,
        component: PaqueteMain,
        autorizado: true
    },
    {
        key: "PK_Roles",
        Clave: "PK_Roles",
        path: "/Roles",
        exact: true,
        component: VRoles,
        autorizado: true
    },
    {
        key: "PK_Pagos",
        Clave: "PK_Pagos",
        path: "/Pagos",
        exact: true,
        component: VPagos,
        autorizado: true
    },
    {
        key: "PK_Pagos_referencia",
        Clave: "PK_Pagos",
        path: "/ClienteReferencia/:referencia",
        exact: true,
        component: VClienteDetalle,
        autorizado: true
    },
    {
        key: "PK_PaueteImagen",
        Clave: "PK_PaueteImagen",
        path: "/PaqueteImagen",
        exact: true,
        component: VPaquetesImagenes,
        autorizado: true
    },
    {
        key: "PK_Mis_Comisiones",
        Clave: "PK_Mis_Comisiones",
        path: "/MisComiciones",
        exact: true,
        component: VMisComisiones,
        autorizado: true
    },
    {
        key: "PK_AdministrarClientes",
        Clave: "PK_AdministrarClientes",
        path: "/AdministrarClientes",
        exact: true,
        component: VClientes,
        autorizado: true
    },
    {
        key: "PK_AdministrarClientes_referencia",
        Clave: "PK_AdministrarClientes",
        path: "/Cliente/:referencia",
        exact: true,
        component: VClientes,
        autorizado: true
    },
    {
        key: "PK_Pagar_Comision",
        Clave: "PK_Pagar_Comision",
        path: "/PagarComision",
        exact: true,
        component: VPagarComision,
        autorizado: true
    },
    {
        key: "PK_Reporte_Pagos",
        Clave: "PK_Reporte_Pagos",
        path: "/ReportePagos",
        exact: true,
        component: VReportePagos,
        autorizado: true
    },
    {
        key: "PK_Reportes",
        Clave: "PK_Reportes",
        path: "/reportes",
        exact: true,
        component: VReportes,
        autorizado: true
    },
    {
        key: "PK_Compras",
        Clave: "PK_Compras",
        path: "/Compras",
        exact: true,
        component: VCompras,
        autorizado: true
    },
    {
        key: "PK_Home",
        Clave: "PK_Home",
        path: "/Home",
        exact: true,
        component: VBienvenida,
        autorizado: true
    },
    {
        key: "PK_Finanzas",
        Clave: "PK_Finanzas",
        path: "/Finanzas",
        exact: true,
        component: VFinanzas,
        autorizado: true
    },
    {
        key: "PK_Finanzas_Cliente_Detalle",
        Clave: "PK_Finanzas",
        path: "/ClienteReferenciaFinanzas/:referencia",
        exact: true,
        component: VClienteDetalle,
        autorizado: true
    },
    {
        key: "PK_Cancelaciones",
        Clave: "PK_Cancelaciones",
        path: "/Cancelaciones",
        exact: true,
        component: VCambios,
        autorizado: true
    },
    {
        key: "PK_Cancelaciones_Referencia",
        Clave: "PK_Cancelaciones",
        path: "/Cancelaciones/:Referencia",
        exact: true,
        component: VCambios,
        autorizado: true
    },
    {
        key: "PK_Cambios_Grupales",
        Clave: "PK_CambiosGrupales",
        path: "/CambiosGrupales",
        exact: true,
        component: CambiosGrupales,
        autorizado: true
    },
    {
        key: "PK_Cambios_Cancelaciones",
        Clave: "PK_Cambios_Cancelaciones",
        path: "/Cambios",
        exact: true,
        component: VCambios,
        autorizado: true
    },
    {
        key: "PK_Cambios_Cancelaciones_Referencia",
        Clave: "PK_Cambios_Cancelaciones",
        path: "/Cambios/:Referencia",
        exact: true,
        component: VCambios,
        autorizado: true
    },
    {
        key: "PK_Reservas",
        Clave: "PK_Reservas",
        path: "/Reservas",
        exact: true,
        component: VReservas,
        autorizado: true
    },
    {
        key: "PK_Aereos",
        Clave: "PK_Aereos",
        path: "/Aereos",
        exact: true,
        component: VAereo,
        autorizado: true
    },
    {
        key: "PK_Aereos_Grupo",
        Clave: "PK_Aereos",
        path: "/Aereos/:ClavePaquete",
        exact: true,
        component: VGrupoAereo,
        autorizado: true
    },
    {
        key: "PK_Aereos_Grupo_Auth",
        Clave: "PK_Aereos",
        path: "/Aereos/Autorizados/:idGrupo",
        exact: true,
        component: VGrupoAereoAuth,
        autorizado: true
    },
    {
        key: "PK_Aereos_Grupo_Cliente",
        Clave: "PK_Aereos",
        path: "/ClienteReferenciaAeereos/:referencia",
        exact: true,
        component: VClienteDetalle,
        autorizado: true
    },
    {
        key: "PK_Liquidaciones",
        Clave: "PK_Liquidaciones",
        path: "/Liquidaciones",
        exact: true,
        component: VLiquidaciones,
        autorizado: true
    },
    {
        key: "PK_Liquidaciones_Grupo",
        Clave: "PK_Liquidaciones",
        path: "/Liquidaciones/:ClavePaquete",
        exact: true,
        component: VGrupoLiquidaciones,
        autorizado: true
    },
    {
        key: "PK_Liquidaciones_Grupo_Auth",
        Clave: "PK_Liquidaciones",
        path: "/Liquidaciones/Autorizados/:idGrupo",
        exact: true,
        component: VGrupoLiquidacionesAuth,
        autorizado: true
    },
    {
        key: "PK_Liquidaciones_Cliente",
        Clave: "PK_Liquidaciones",
        path: "/ClienteReferenciaLiquidaciones/:referencia",
        exact: true,
        component: VClienteDetalle,
        autorizado: true
    },
    {
        key: "PK_Reservas_Cliente",
        Clave: "PK_Reservas",
        path: "/ClienteReferenciaReserva/:referencia",
        exact: true,
        component: VClienteDetalle,
        autorizado: true
    },
    {
        key: "PK_Cotizador",
        Clave: "PK_Cotizador",
        path: "/Cotizador",
        exact: true,
        component: VCotizador,
        autorizado: true
    },
    {
        key: "PK_Metodos_Pago",
        Clave: "PK_Metodos_Pago",
        path: "/metodosPago",
        exact: true,
        component: VMetodoPago,
        autorizado: true
    },
    {
        key: "PK_Devoluciones",
        Clave: "PK_Devoluciones",
        path: "/devoluciones",
        exact: true,
        component: VDevoluciones,
        autorizado: true
    },
    {
        key: "PK_Facturacion",
        Clave: "PK_Facturacion",
        path: "/facturas",
        exact: true,
        component: VFacturas,
        autorizado: true
    },
    {
        key: "PK_COTIZACIONES_ADMIN",
        Clave: "PK_COTIZACIONES_ADMIN",
        path: "/cotizaciones",
        exact: true,
        component: VCotizaciones,
        autorizado: true
    },
    {
        key: "PK_EXTRAS_CONTRATADOS",
        Clave: "PK_EXTRAS_CONTRATADOS",
        path: "/extrasContratados",
        exact: true,
        component: VExtrasContratados,
        autorizado: true
    },
    {
        key: "PK_COTIZACIONES_REVIEW_ADMIN",
        Clave: "PK_COTIZACIONES_REVIEW_ADMIN",
        path: "/cotizacionesReview",
        exact: true,
        component: VCotizacionesAdmin,
        autorizado: true
    },
]
